<template>
  <div class="papa-krabbelgruppe">

    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-text">
        <h1>Krabbelgruppe für Väter in Koblenz</h1>
        <p>
          Ein Ort für Austausch, Spiel und Fragen – speziell für Väter mit ihren Babies. Weil es das sonst viel zu selten gibt. Offen, entspannt und auf Augenhöhe.
        </p>
        <button 
          class="cta-button" 
          @click="$router.push({ 
            path: '/kontakt', 
            query: { 
              topic: 'Papa-Krabbelgruppe', 
              message: 'Hallo Maike, \nich möchte mich mit meinem Kind <Name>(<Alter>) für die Papa-Krabbelgruppe anmelden. \nViele Grüße \n<Name> \nRechnungsadresse: \n' 
            } 
          })"
        >
          Jetzt Platz anfragen
        </button>
      </div>
      <div class="hero-image">
        <img src="@/assets/papa_krabbelgruppe.jpg" alt="Krabbelgruppe für Väter in Koblenz" width="300" height="auto"/>
      </div>
    </section>

    <section>
      <h2>Väter mal ganz unter sich</h2>
      <p>
        Immer mehr Familien entscheiden sich gegen die klassische Rollenverteilung und immer mehr Väter gehen in Elternzeit oder übernehmen einen großen Teil der Care-Arbeit. <strong>Trotzdem sind auch 2026 noch bei fast allen Elternangeboten die meisten Teilnehmenden Mütter.</strong> Diese Krabbelgruppe richtet sich deshalb ganz bewusst an <strong>Väter mit Babies in den ersten 18 Monaten</strong> und bietet vor allem Raum für Austausch: 
      </p>
      <p>
        <strong>Welche Rolle möchte ich als Papa einnehmen und wie finde ich meinen Platz?</strong> Wie kann ich als Vater eine sichere Bindung aufbauen – <strong>trotz 9 Monaten Rückstand und ohne Stillen?</strong> Auf diese Fragen gibt es keine richtigen oder falschen Antworten. <strong>Wir sind gespannt auf EURE Antworten!</strong>
      </p>
      <p>
        Hier geht es <strong>nicht um perfekte Erziehung oder fixe Themenpläne</strong>, sondern um das, was euch gerade beschäftigt: Alltag, Partnerschaft, Schlaf, Windeln, Tragen, Füttern – oder einfach den ganz normalen Spagat zwischen all den neuen und alten Ansprüchen, die die Umwelt und man selbst an einen hat.
      </p>
      <p>
        <strong>Die Leitung übernimmt mein Mann Johannes</strong> – genauso zweifacher Vater – <strong>zusammen mit unserem Baby.</strong><br/> 
        Bei Bedarf komme ich dazu und beantworte als Babyschlaf- und Beikostexpertin eure Fragen. Auch dort gilt: <strong>Der Raum gehört euch Vätern – ihr bestimmt die Inhalte.</strong>
      </p>
      <p>
        Ob du gerade frisch Papa geworden bist oder dein Baby schon die Wohnung unsicher macht – <strong>ihr seid alle herzlich willkommen!</strong>
      </p>
    </section>
    
    <section>
      <h2>Termine & Rahmenbedingungen der fortlaufenden Krabbelgruppe</h2>
      <ul>
        <li><strong>Wann:</strong> Mittwochs, 16:15 – 17:45 Uhr</li>
        <li><strong>Ort:</strong> Koblenz-Metternich, wetterabhängig innen oder draußen</li>
        <li><strong>Kursgebühr:</strong> flexible 5er-Karte für 25 €</li>
      </ul>
    </section>
    
    <section class="kontakt-cta">
      <h2>Interesse an einem Platz?</h2>
      <p>
        Schreib uns einfach eine kurze Nachricht – wir melden uns schnellstmöglich mit weiteren Infos zurück.
      </p>
      <button 
        class="cta-button" 
        @click="$router.push({ 
          path: '/kontakt', 
          query: { 
            topic: 'Papa-Krabbelgruppe', 
            message: 'Hallo Maike, \nich möchte mich mit meinem Kind <Name>(<Alter>) für die Papa-Krabbelgruppe anmelden. \nViele Grüße \n<Name> \nRechnungsadresse: \n' 
          } 
        })"
      >
        Platz anfragen
      </button>
    </section>

  </div>
</template>

<script>
export default {
  name: "Papa-Krabbelgruppe"
};
</script>

<style>
.papa-krabbelgruppe {
}
</style>
